import { TechnicalData } from 'types/api/product.type';

import { useActions } from './Actions.hooks';
import * as S from './Actions.styles';

export function Actions({
  technicalData,
}: {
  technicalData?: TechnicalData;
}): React.ReactElement {
  const { buttonComponents } = useActions({ technicalData });

  return <S.Container>{buttonComponents}</S.Container>;
}
